"use client";
import React from "react";
import {
  APIProvider,
  Map,
  AdvancedMarker,
  Pin,
} from "@vis.gl/react-google-maps";

const MapContainer = () => {
  const mapStyles = {
    height: "500px",
    width: "100%",
  };

  const position = {
    lat: 1.354787251077238,
    lng: 103.87776630378643,
  };

  return (
    <APIProvider apiKey={"AIzaSyBMU4wZr13ukil4E8pLmA4lhN0sJeDyFRg"}>
      <div className="container" style={mapStyles}>
        <Map
          defaultZoom={14}
          defaultCenter={position}
          mapId={"21c5cd92df932e43"}
        >
          <AdvancedMarker position={position}>
            <Pin />
          </AdvancedMarker>
        </Map>
      </div>
    </APIProvider>
  );
};

export default MapContainer;
